export default __webpack_public_path__ + "static/media/fasting_13_11@3x.2568cc3a.jpg";